module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-25MARZO-25-OK__1_-b74cd0ae491238c905ed72dd9ed93cbd.png";